<template>
  <div class="tags" v-show="showTags" effect="dark">
    <el-tag v-for="(item, index) in tagsList" :key="index" closable @close="closeTag(index)" type="info" :class="{ 'active': isActive(item.path) }">
      <router-link class="tags-title" :to="item.path" effect="dark">
        <span class="zero" :class="{ 'zactive': isActive(item.path) }"></span>
        {{ item.title }}
      </router-link>
    </el-tag>
    <span class="right-text">技术支持：15893725561</span>
  </div>
</template>

<script>
import bus from '@/components/base/bus';

const ROOT_TAG = '/welcome';
const EVENT_NAME = 'tags';

export default {
  name: 'Tags',
  data() {
    return {
      tagsList: [],
    };
  },
  created() {
    if (sessionStorage.getItem('tagsList')) {
      this.tagsList = JSON.parse(sessionStorage.getItem('tagsList'));
    } else {
      this.setTags(this.$route);
    }
  },
  methods: {
    // 设置标签
    setTags(route) {
      // 判断路由列表里面有没有相同的数据
      if (Object.getOwnPropertyNames(route.params).length === 0) {
        const isExitRoute = this.tagsList.some((item) => item.path === route.path);
        if (route.path !== '/welcome' || route.title !== '主页') {
          // 判断路由数组长度最大值为5
          if (!isExitRoute) {
            if (this.tagsList.length < 10 && !route.meta.breadNumber) {
              this.tagsList.push({
                // title: route.meta.title,
                // path: route.path,
                title: route.meta.title,
                path: route.path,
              });
            } else {
              this.tagsList.splice(0, 1);
              this.tagsList.push({
                // title: route.meta.title,
                // path: route.path,
                title: route.meta.title,
                path: route.path,
              });
            }
          }
        }
        bus.$emit(EVENT_NAME, this.tagsList);
      }
    },
    isActive(path) {
      return path === this.$route.path;
    },
    // 删除标签
    closeTag(index) {
      if (!(this.tagsList[index].path === ROOT_TAG && this.tagsList.length === 1)) {
        const delItem = this.tagsList.splice(index, 1)[0];
        const item = this.tagsList[index]
          ? this.tagsList[index]
          : this.tagsList[index - 1];
        if (item) {
          // eslint-disable-next-line no-unused-expressions
          delItem.path === this.$route.path && this.$router.push(item.path);
        } else {
          this.$router.push('/welcome');
        }
      }
      if (this.tagsList.length === 0) {
        this.$router.push('/welcome');
      }
    },
  },
  computed: {
    showTags() {
      return this.tagsList.length > 0;
    },
  },
  watch: {
    $route(to, form) {
      this.setTags(to);
    },
  },
  beforeDestroy() {
    sessionStorage.setItem('tagsList', JSON.stringify(this.tagsList));
  },
};

</script>

<style scoped>
.tags {
  position: fixed;
  z-index: 20;
  width: calc(100%);
  margin: auto;
  margin-bottom: 20px;
  margin-left: -14px;
  padding: 5px 0 5px 5px;
  background-color: white;
  padding-left: 18px;
  top: 52px; /* 设置离顶部的距离*/
}

.tags .el-tag {
  margin: 0 0 0 3px;
  cursor: pointer;
}

.tags .el-tag--info {
  background-color: white;
  border-radius: 0;
}

.tags .el-tag.active {
  background: #f1f1f1;
  color: black;
}

.tags .el-tag.active .tags-title {
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
}

.tags-title {
  color: black;
  text-decoration: none;
}

.tags .el-tag.active .zero {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #f1f1f1;
}

.tags .el-tag.active .zactive {
  background-color: rgb(64, 158, 255);
}

.right-text {
  position: absolute;
  top: 10px;
  right: 300px; /* 调整右侧内边距 */
  margin-top: 0; /* 调整上方间距 */
  color: black;
  font-size: 13px; /* 调整字体大小 */
}
.text {
  display: inline-block;
  width: 11em;
  overflow: hidden;
  margin: auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/Tags.vue